import Vue from 'vue'
import App from './App.vue'
import router from './router'
import NowUiKit from './plugins/now-ui-kit';
import i18n from './i18n'
import AOS from 'aos'
import 'aos/dist/aos.css'
import axios from 'axios';
import store from './store';
import device from "vue-device-detector";

Vue.config.productionTip = false

Vue.use(NowUiKit);
Vue.use(device);
AOS.init();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted: async function () {
    let parameters = this.$route.query;
    // let urlParam = '?';
    // if (parameters.utm_source != null) {
    //   urlParam += "utm_source=" + parameters.utm_source;
    // }
    // if (parameters.utm_medium != null) {
    //   if (urlParam != '?') {
    //     urlParam += "&";
    //   }
    //   urlParam += "utm_medium=" + parameters.utm_medium;
    // }
    // if (parameters.ref != null) {
    //   if (urlParam != '?') {
    //     urlParam += "&";
    //   }
    //   urlParam += "ref=" + parameters.ref;
    // }
    // if (urlParam == '?') {
    //   urlParam = '';
    // }
    localStorage.parameters = JSON.stringify(parameters);
    localStorage.urlParam = window.location.search;//urlParam;

    // try {
    //   let device = '';
    //   if (this.$device.mobile) {
    //     device = 'mobile/';
    //     if (this.$device.android || this.$device.androidPhone) {
    //       device += 'android';
    //     }
    //     else {
    //       device += 'ios';
    //     }
    //   }
    //   else {
    //     device = 'pc';
    //   }

    //   await axios.post('https://api-stats.leagueofkingdoms.com/api/visit', {utm_source:parameters.utm_source, utm_medium: parameters.utm_medium, language: navigator.language, device: device, ref: parameters.ref});
    // }
    // catch(err) {
    //   console.log('err - ', err);
    // }
  }
}).$mount('#app')
